import type { GetProductResponse, UpdateCartItemResponse } from '@vue-storefront/prestashop-api';
import { useSdk } from '~/sdk';

export const useAddToCartText = (response: MaybeRefOrGetter<GetProductResponse['psdata']>) => {
  const { t } = useI18n();
  const data = computed(() => toValue(response))

  const text = computed(() => {
    if (! data.value) {
      return t('Loading') + '...';
    }

    if (data.value.variants || data.value.id_product_attribute == '0') {
      return t('Add to cart');
    }

    if (data.value?.availability?.toLowerCase() === 'backorder') {
      return t('Preorder', 'Preorder');
    }

    return t('View product');
  });

  return { text };
};

export const useAddToCart = () => {
  const state = reactive<{
    loading: boolean;
    error: string | null;
    data: UpdateCartItemResponse | null;
  }>({
    loading: false,
    error: null,
    data: null,
  });

  const { addOrRemoveFromCart } = useAnalytics();
  const { t } = useI18n();

  const generalStore = useGeneralStore();

  const { data: cart, refresh: refreshCart } = useCart();

  const execute = async (params: {
    id_product: GetProductResponse['psdata']['id_product'];
    id_product_attribute: GetProductResponse['psdata']['id_product_attribute'];
    qty: number;
  }) => {
    if (!params) {
      return;
    }

    state.loading = true;

    const data = await useSdk().commerce.updateCartItem({
      id_product: params.id_product,
      id_product_attribute: params.id_product_attribute,
      qty: params.qty,
    });

    addOrRemoveFromCart({ ...params }, 'add_to_cart');

    state.data = data;
    state.loading = false;

    Promise.all([refreshCart()]);

    generalStore.toggleCartSidebar();

    return data;
  };

  return {
    ...toRefs(state),
    execute,
  };
};
